/**
 * Объединяет текущие роли пользователя с выбранными оператором.
 *
 * Бэк-эндпоинт ролей работает как replace, а при добавлении уже существующего
 * пользователя в панель его прежние роли (например `USER`) терять нельзя —
 * иначе он потеряет доступ в мобильное приложение.
 *
 * @returns id ролей без дубликатов, в порядке «текущие, затем новые»
 */
export function mergeRoleIds(current: readonly string[], selected: readonly string[]): string[] {
  const merged: string[] = [];
  for (const id of [...current, ...selected]) {
    if (id && !merged.includes(id)) merged.push(id);
  }
  return merged;
}
